// extracted by mini-css-extract-plugin
export default {"content":"Faq_content__hBNnc","logo":"Faq_logo__mdqI1","question":"Faq_question__gH7Yg","answers":"Faq_answers__0ijZB","questions":"Faq_questions__SWrN4","plus":"Faq_plus__gRJQy"};